import ProductService from '_services/rest/modules/product';

export default {
  state: {
    cost: null,
    costList: null,
  },
  mutations: {
    setCost(state, response) {
      state.cost = response;
    },
    setCostList(state, response) {
      state.costList = response;
    },
  },
  actions: {
    getCostList({ commit }, params) {
      return ProductService.getList(params)
        .then(response => {
          commit('setCostList', response);
        });
    },
    getCost({ commit }, params) {
      return ProductService.getProductById(params)
        .then(response => {
          commit('setCost', response);
        });
    },
    setCost({ commit }, params) {
      commit('setCost', params);
    },
  },
};
